import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, role }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/login" />;
  }

  // If a role is required and the user doesn't have it, redirect to home
  if (role) {
    if (role === 'super_admin') {
      const isPlatformAdmin = user?.is_super_admin && user?.company_id === 1;
      return isPlatformAdmin ? children : <Navigate to="/" />;
    }

    if (role === 'admin') {
      // Admin users are those without a company_id
      if (user?.company_id === null || user?.company_id === undefined || user?.is_super_admin) {
        return children;
      }
    }

    // Check for other roles if necessary
    if (user?.role !== role) {
      return <Navigate to="/" />;
    }
  }


  return children;
};

export default ProtectedRoute;
